import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEmployeeLoading = (state: TRootState): boolean =>
  arrayContains(state.employee.openRequests, [
    Actions.findEmployeeRequest.type,
    Actions.findEmployeesRequest.type,
    Actions.searchEmployeesRequest.type,
    Actions.createEmployeeRequest.type,
    Actions.updateEmployeeRequest.type,
    Actions.deleteEmployeeRequest.type,
  ]);
